import {React, useState} from 'react';
import {Grid,Box, Button,Paper,Stack,Typography} from '@mui/material';
import {Add, Groups} from '@mui/icons-material';
import '../../App.css'
import LeaveMasterForm from './LeaveMasterForm';
import LeaveTypesTable from '../table-data/LeaveTypesTable';
import Popup from '../Popup';

function ViewLeaveTypeMaster(){

const [openPopup, setOpenPopup] = useState(false);
  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "30px", fontWeight: "500px"}} >
      <Paper elevation={0} sx={{width: "1000px"}}>
        <Grid className="form-title" style={{marginBottom: "-60px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Leave Master</Typography> </Grid>
          <Grid item> <Groups style={{marginLeft: "-30px"}}  sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

           <Stack display="flex" sx={{alignItems: "flex-end" }}>
                                     <Button
                                     style={{width: "130px"}}
                                       className="form-btn"
                                       variant="outlined"
                                       color="success"
                                       onClick={() => setOpenPopup(true)}
                                       startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                                       sx={{
                                         whiteSpace: "nowrap",
                                         textTransform: "none"
                                       }}
                                     >
                                       Add Leave
                                     </Button>
                                   </Stack>

            <LeaveTypesTable />




            </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <LeaveMasterForm title="Add New Leave" fetch_id={9999} />
          {/*<AddEmployeeForm/>
          <EmployeeSalaryForm/>
          <LeaveDataMaster/>*/}
        </Popup>

      </Paper>
    </Box>
  )
}

export default ViewLeaveTypeMaster;
